import React, { useState, useEffect, useRef } from "react";
import { View, Text, TextInput, TouchableOpacity, Modal } from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Attribute from "../Firestore/Attribute";

import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { observer, Observer } from "mobx-react";
import { useDevice } from "../_layout";

const AddPredefinedAttributeView = ({
  isVisible,
  onClose,
  coach,
  attribute,
  title,
  setTitle,
  subtitle = "",
  setSubtitle,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const [predefinedName, setPredefinedName] = useState(
    attribute && attribute.name ? attribute.name : ""
  );
  const predefinedText =
    attribute && attribute.name
      ? attribute.name
      : "newPredefinedAttribute-string";
  const titleKey = attribute
    ? "editPredefinedAttribute-string"
    : "addPredefinedAttribute-string";
  const modalTitle = attribute
    ? t(titleKey)
    : t(titleKey).toUpperCase();

  // Prevent keyboard events from reaching other components when modal is open
  useEffect(() => {
    if (!isVisible) return;

    const handleKeyDown = (event) => {
      // Stop the event from propagating to other listeners (like SearchBar)
      event.stopPropagation();
    };

    // Add event listener with capture=true to catch events before they reach other listeners
    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [isVisible]);

  const cancel = () => {
    setPredefinedName("");
    setTitle();
    setSubtitle?.();
    onClose();
  };

  const Buttons = observer(({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";
    const canAdd = predefinedName !== "";

    const titleItems = (coach.customPredefinedAttributes || []).filter(
      (item) => item.title === title
    );

    const highestOrder = titleItems.reduce((maxOrder, item) => {
      const orderValue = item?.order;
      if (typeof orderValue === "number" && Number.isFinite(orderValue)) {
        return Math.max(maxOrder, orderValue);
      }
      return maxOrder;
    }, -Infinity);

    const nextOrder = highestOrder === -Infinity ? 1000 : highestOrder + 1;
    const [isHovered, setIsHovered] = useState(false);

    const Save = () => {
      if (canAdd) {
        const newPredefinedAttribute = new Attribute(
          uuidv4(),
          predefinedName,
          title,
          "",
          nextOrder,
          true,
          false,
          null,
          null
        );
        coach.customPredefinedAttributes.push(newPredefinedAttribute);
        coach.updateCoachTransactionAttributes(newPredefinedAttribute.id);
        coach.startOrResetBatchTimer();

        onClose();
      }
    };
    return bool ? (
      <TouchableOpacity
        onPress={Save}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.8 : canAdd ? 1 : 0.7,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  });

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={GlobalStyles.modalView}>
            <View
              style={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={Fonts.bold18Centered}>{modalTitle}</Text>
              <TextInput
                style={[
                  GlobalStyles.textInputStyle,
                  {
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={t(predefinedText)}
                placeholderTextColor={Colors.grayColor}
                value={predefinedName}
                onChangeText={setPredefinedName}
                maxLength={35}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                autoFocus={true}
              />

              <View style={{ marginVertical: 20, width: "100%" }}>
                {title != "" && (
                  <View style={GlobalStyles.HStack}>
                    <Text style={Fonts.bold14}>{t("typeDots-string")}</Text>
                    <Text style={Fonts.medium14}>{t(title)}</Text>
                  </View>
                )}
              </View>
            </View>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  justifyContent: "center",
                  width: "100%",
                  justifyContent: "space-around",
                  // marginTop: 20,
                },
              ]}
            >
              <Buttons bool={false} />
              <Buttons bool={true} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

// const styles = StyleSheet.create({
//   container: {
//     // flexDirection: "row",
//     // alignItems: "center",
//   },
//   textInputStyle: {
//     width: "50%",

//     height: 40,
//     borderColor: Colors.borderColor,
//     backgroundColor: Colors.whiteColor,
//     color: Colors.blackColor,
//     borderWidth: 0.1,
//     marginTop: 10,
//     padding: 10,
//     borderRadius: 10,
//     outlineStyle: "none",
//     //flex: 1,
//   },
// });

export default AddPredefinedAttributeView;
